
__webpack_require__.svgSprite = function(id) {
    return "/static/svg/sprite.05734b81.svg#" + id;
};
          